import { AttendanceStateTypes, AttendanceActionTypes } from "./Attendance.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AttendanceStateTypes = {
  fetchAll: resetApiCallState([]),
};

const AttendanceReducer = (
  state: AttendanceStateTypes = INITIAL_STATE,
  action: any
): AttendanceStateTypes => {
  switch (action.type) {
    case AttendanceActionTypes.FETCH_ALL_ATTENDANCE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AttendanceActionTypes.FETCH_ALL_ATTENDANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AttendanceActionTypes.FETCH_ALL_ATTENDANCE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AttendanceActionTypes.FETCH_ALL_ATTENDANCE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AttendanceReducer;
